import type { ReactNode } from 'react';

import type { LayerVisibility } from '../hooks';

/* -------------------------------------------------------------------------- */
/*                               Main component                               */
/* -------------------------------------------------------------------------- */

/**
 * A simple wrapper component that applies visibility and opacity from a LayerVisibility object to its children.
 * This allows us to easily control the visibility of entire layers/groups of SVG elements in our canvas.
 *
 * @example
 * ```tsx
 *   const blastLayerVisibility = useLayerVisibility({ visible: true, opacity: 0.8 });
 *
 *   <LayerMask layerVisibility={blastLayerVisibility}>
 *     <PolygonBackground polygon={blast.polygon} />
 *   </LayerMask>
 * ```
 */
const LayerMask = ({ layerVisibility, children }: { layerVisibility: LayerVisibility; children: ReactNode }) => {
  if (!layerVisibility.isVisible) return null;

  return <g opacity={layerVisibility.opacity}>{children}</g>;
};

/* -------------------------------------------------------------------------- */
/*                                   Exports                                  */
/* -------------------------------------------------------------------------- */

export { LayerMask };
